import Storage from "@/tools/storage";
const state = {
  hospitalsInfo: {
    name: "",
    id: "",
    search: "",
    is_bar_code: 1
  }
};
const getters = {
  //get
  getDemoValue: state => state.hospitalsInfo
};
const mutations = {
  //set
  setDemoValue(state, hospitalsInfo) {
    state.hospitalsInfo = hospitalsInfo
  }
};
export default {
  state,
  getters,
  mutations
};